import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { get_fetch,post_fetch, post_fetch_files } from 'model/FetchManage'
import { setUserInfo } from 'helpers/authUtils';

import {
  GET_PROFILE,
  GET_PROFILE_PICTURE
} from '../../constants/actionTypes'
import {
  getprofile, getprofilepicture
} from './actions'
import cmm from 'constants/common'

function* _getProfile() {
  try {
    console.log('get -> post')
    const response = yield call(post_fetch, cmm.SERVER_API_URL + '/org/myinfo')
    if (response.status == 200 && response.message.length > 0) {
      yield setUserInfo({
        permissions:response.message[0].permissions, 
        user_name:response.message[0].user_name, 
        wgroupName:response.message[0].organization
      })
    }
    yield put(getprofile.success(response))
  } catch (error) {
    yield put(getprofile.error(error))
  }
}

function* _getProfilePicture({ payload: { body } }) {
  try {
    const response = yield call(post_fetch_files, cmm.SERVER_API_URL + '/org/myinfo_photo', body)
    yield put(getprofilepicture.success(response))
  } catch (error) {
    yield put(getprofilepicture.error(error))
  }
}

function* watchGetProfile() {
  yield takeEvery(GET_PROFILE, _getProfile)
}

function* watchGetProfilePicture() {
  yield takeEvery(GET_PROFILE_PICTURE, _getProfilePicture)
}

function* profileSaga() {
  yield all([
    fork(watchGetProfile),
    fork(watchGetProfilePicture),
  ])
}

export default profileSaga
